// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YWyZD","buttons":"styles_buttons__TORbe"};